import { Navigate } from 'react-router-dom'
import { useAuth, homePathFor } from '../contexts/AuthContext'

export default function Landing() {
  const { user } = useAuth()

  // Signed-in users go to their own side of the product; everyone else logs in.
  return <Navigate to={user ? homePathFor(user) : '/login'} replace />
}
